import React, { useContext, useState, useEffect } from "react";
import AccreditationInput from "../../../components/AccreditationInput/AccreditationInput";
import AccreditationButton from "../../../components/AccreditationButton/AccreditationButton";
import { icons } from "../../../constants";
import { vehiclesTableOptions } from "../../../constants/tables";
import { getVehicleTypeLabel } from "../../../utils/vehicleTypes";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { useTheme } from "../../../utils/ThemeContext";
import { useAlert } from "../../../utils/AlertContext";
import { useNavigate } from "react-router-dom";
import Modal from "../../../components/Modal/Modal";
import { apiRoutes } from "../../../utils/apiRoutes";
import {
  deleteData,
  createData,
  fetchData,
  updateData,
  exportToCSV,
} from "../../../utils/methods";
import ConfirmationModal from "../../../components/Modal/components/ConfirmationModal";
import TableThird from "../../../components/TableThird/TableThird";
import { addFieldToObjects } from "../../../utils/addFieldToObjects";
import { sortByCreatedAtIfExists } from "../../../utils/sortByCreatedAtIfExists";

const VehiclesPanel = ({
  event,
  vehicles,
  setVehicles,
  vehiclesDataLength,
  setVehiclesDataLength,
  eventId,
  activeGroup,
  isActive,
}) => {
  const { t } = useContext(TranslationsContext);
  const [searchValue, setSearchValue] = useState("");

  const isDeadlinePassed = (obj) => {
    console.log("oj", obj);
    if (!obj?.prijava_do || !obj?.prijava_od) return false; // ako nema krajnjeg datuma

    const start = new Date(obj?.prijava_od || null);
    const end = new Date(obj?.prijava_do || null);
    const now = new Date();

    console.log(start, end);

    // ako je sada između start i end
    console.log("mow", now >= start && now <= end);
    return now >= start && now <= end;
  };
  const { theme } = useTheme();
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");
  const [editVehicleObject, setEditVehicleObject] = useState();
  const [editVehicleModalOpen, setEditVehicleModalOpen] = useState(false);
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [openAddVehicleModal, setOpenAddVehicleModal] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 300);
    return () => clearTimeout(handler);
  }, [searchValue]);

  // Load vehicles data
  useEffect(() => {
    const loadVehicles = async () => {
      setIsLoadingData(true);
      try {
        console.log("Fetching vehicles for eventId:", eventId);
        const response = await fetchData(
          `${apiRoutes.vehicles}?dogadjajId=${eventId}&offset=0&take=100&orderBy=createdAt&orderDirection=desc`
        );
        console.log("Vehicles response:", response);
        if (response && response.data) {
          const vehiclesData = Array.isArray(response.data)
            ? response.data
            : response.data?.data || [];
          const sortedVehicles = sortByCreatedAtIfExists(vehiclesData);
          setVehicles(sortedVehicles);
          setVehiclesDataLength(vehiclesData.length);
          console.log("Loaded vehicles:", vehiclesData);
        }
      } catch (error) {
        console.error("Error loading vehicles:", error);
        showAlert("Error loading vehicles", "error");
      } finally {
        setIsLoadingData(false);
      }
    };

    if (eventId && isActive) {
      loadVehicles();
    }
  }, [eventId, isActive, setVehicles, setVehiclesDataLength, showAlert]);

  // Transform vehicles data to match TableThird format
  const mappedVehicles = vehicles
    .filter((vehicle) => {
      if (!debouncedSearchValue) return true;
      const searchTerm = debouncedSearchValue.toLowerCase();
      return (
        vehicle.tip?.toLowerCase().includes(searchTerm) ||
        getVehicleTypeLabel(vehicle.tip, t).toLowerCase().includes(searchTerm) ||
        vehicle.registracija?.toLowerCase().includes(searchTerm) ||
        vehicle.entitet?.toLowerCase().includes(searchTerm) ||
        vehicle.marka?.toLowerCase().includes(searchTerm) ||
        vehicle.model?.toLowerCase().includes(searchTerm) ||
        vehicle.dogadjajGrupa?.naziv?.toLowerCase().includes(searchTerm) ||
        vehicle.korisnik?.ime?.toLowerCase().includes(searchTerm) ||
        vehicle.korisnik?.prezime?.toLowerCase().includes(searchTerm)
      );
    })
    .map((vehicle) => {
      const mappedVehicle = { id: vehicle.id };
      mappedVehicle.className = "vehicles-table";

      vehiclesTableOptions(t).forEach((option) => {
        if (option.name === "actions") {
          mappedVehicle[option.name] = ""; // Actions will be handled by TableThird
        } else if (option.name === "tip") {
          mappedVehicle[option.name] = getVehicleTypeLabel(vehicle.tip, t);
        } else {
          mappedVehicle[option.name] = vehicle[option.name] || "";
        }
      });

      return mappedVehicle;
    });

  const tableHeader = addFieldToObjects(
    vehiclesTableOptions(t),
    "class",
    "vehicles-table"
  );

  const handleSortChange = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const sortData = (data, field, direction) => {
    if (!field) return data;
    return [...data].sort((a, b) => {
      const aVal = a[field] || "";
      const bVal = b[field] || "";
      if (direction === "asc") {
        return aVal.localeCompare(bVal);
      } else {
        return bVal.localeCompare(aVal);
      }
    });
  };

  const onActionClick = (key) => {
    const vehicle = vehicles.find((v) => v.id === key);
    if (vehicle) {
      setEditVehicleObject(vehicle);
      setEditVehicleModalOpen(true);
    }
  };

  const onDeleteClick = async () => {
    try {
      const response = await deleteData(`${apiRoutes.vehicles}/${deleteId}`);
      if (response && response.data) {
        setVehicles(vehicles.filter((v) => v.id !== deleteId));
        setVehiclesDataLength(vehiclesDataLength - 1);
        showAlert(t("VEHICLE_DELETED_SUCCESSFULLY"), "success");
      } else {
        showAlert(t("ERROR_DELETING_VEHICLE"), "error");
      }
    } catch (error) {
      console.error("Error deleting vehicle:", error);
      showAlert(t("ERROR_DELETING_VEHICLE"), "error");
    } finally {
      setOpenConfirmationModal(false);
    }
  };

  const handleAddVehicle = async (vehicleData) => {
    try {
      const response = await createData(
        apiRoutes.vehicles,
        {
          ...vehicleData,
          dogadjajId: eventId,
        },
        showAlert,
        navigate,
        t
      );
      if (response && response.data) {
        console.log("API Response data:", response.data);
        console.log("Vehicle data sent:", vehicleData);

        // Ensure the new vehicle has all required fields
        const newVehicle = {
          id: response.data.id,
          tip: response.data.tip || vehicleData.tip,
          registracija: response.data.registracija || vehicleData.registracija,
          entitet: response.data.entitet || vehicleData.entitet,
          marka: response.data.marka || vehicleData.marka,
          model: response.data.model || vehicleData.model,
          dogadjajId: response.data.dogadjajId || eventId,
          dogadjajGrupaId:
            response.data.dogadjajGrupaId || vehicleData.dogadjajGrupaId,
          // Include any additional fields from the response
          ...response.data,
        };

        console.log("New vehicle object:", newVehicle);

        setVehicles([newVehicle, ...vehicles]);
        setVehiclesDataLength(vehiclesDataLength + 1);
        showAlert(t("VEHICLE_ADDED_SUCCESSFULLY"), "success");
      } else {
        showAlert(t("ERROR_ADDING_VEHICLE"), "error");
      }
    } catch (error) {
      console.error("Error adding vehicle:", error);

      // Handle specific error types
      if (
        error?.code === "DUPLICATE" ||
        error?.details?.includes("duplicate")
      ) {
        showAlert(
          t("VEHICLE_ALREADY_EXISTS") ||
            "Vehicle with this information already exists",
          "error"
        );
      } else {
        showAlert(t("ERROR_ADDING_VEHICLE"), "error");
      }
    }
  };

  const handleUpdateVehicle = async (updatedVehicle) => {
    try {
      // Remove id from the data object since it's already in the URL
      const { id, ...vehicleData } = updatedVehicle;
      const response = await updateData(
        `${apiRoutes.vehicles}/${id}`,
        vehicleData,
        showAlert,
        navigate,
        t
      );
      if (response && response.data) {
        setVehicles(
          vehicles.map((v) => (v.id === updatedVehicle.id ? updatedVehicle : v))
        );
        showAlert(t("VEHICLE_UPDATED_SUCCESSFULLY"), "success");
      } else {
        showAlert(t("ERROR_UPDATING_VEHICLE"), "error");
      }
    } catch (error) {
      console.error("Error updating vehicle:", error);
      showAlert(t("ERROR_UPDATING_VEHICLE"), "error");
    }
  };

  const handleExportCSV = () => {
    const visibleData = sortData(mappedVehicles, sortField, sortDirection);
    const columns = vehiclesTableOptions(t);
    
    // Generate filename: event-name-vehicles.csv
    const eventName = event?.naziv || "event";
    const sanitizedEventName = eventName
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
    const tabName = "vehicles";
    const filename = `${sanitizedEventName}-${tabName}.csv`;
    
    exportToCSV(visibleData, columns, filename);
    showAlert(t("EXPORT_SUCCESSFUL") || "Export successful", "success");
  };

  return (
    <div className="flex-direction-column gap-12">
      <div className="flex-direction-row flex-wrap gap-24 justify-between panel-search-buttons">
        <AccreditationInput
          type="search"
          placeholder={t("SEARCH_VEHICLES")}
          setInputValue={(value) => setSearchValue(value)}
          value={searchValue}
          className="justify-end"
          style={{ minHeight: "48px" }}
        />
        <div className="flex-direction-column gap-8 event-number-buttons">
          <div className="flex-direction-row gap-8 first-event-buttons">
            <AccreditationButton
              type="export"
              title={t("EXPORT") || "Export"}
              icon={icons.export_icon}
              onClick={handleExportCSV}
              style={{ minHeight: "48px" }}
            />
            <AccreditationButton
              type="add"
              title={t("ADD")}
              icon={theme === "light" ? icons.add : icons.add_btn_dark}
              onClick={() => setOpenAddVehicleModal(true)}
              disabled={event && !isDeadlinePassed(event)}
              style={{ minHeight: "48px" }}
            />
          </div>
        </div>
      </div>

      {/* Vehicles Table */}
      <TableThird
        options={tableHeader}
        data={sortData(mappedVehicles, sortField, sortDirection)}
        onClick={(key) => onActionClick(key)}
        onDeleteClick={(id) => {
          setDeleteId(id);
          setOpenConfirmationModal(true);
        }}
        t={t}
        isLoadingData={isLoadingData}
        sortField={sortField}
        sortDirection={sortDirection}
        onSortChange={handleSortChange}
        classNameContent="small-content"
        query={debouncedSearchValue}
      />

      {/* Add Vehicle Modal */}
      {openAddVehicleModal && (
        <Modal
          type="vehicle"
          onCloseClick={() => setOpenAddVehicleModal(false)}
          eventId={eventId}
          dogadjajGrupaId={activeGroup?.id}
          handleAddData={handleAddVehicle}
        />
      )}

      {/* Edit Vehicle Modal */}
      {editVehicleModalOpen && editVehicleObject && (
        <Modal
          type="vehicle"
          onCloseClick={() => setEditVehicleModalOpen(false)}
          object={editVehicleObject}
          editing
          eventId={eventId}
          dogadjajGrupaId={activeGroup?.id}
          handleUpdateData={handleUpdateVehicle}
        />
      )}

      {/* Confirmation Modal */}
      {openConfirmationModal && (
        <ConfirmationModal
          handleDeclineClick={() => setOpenConfirmationModal(false)}
          handleConfirmClick={onDeleteClick}
          term={
            vehicles.find((v) => v.id === deleteId)?.registracija ||
            vehicles.find((v) => v.id === deleteId)?.tip
          }
        />
      )}
    </div>
  );
};

export default VehiclesPanel;
